export default "__VITE_ASSET__b4cfd7c6__"